import { create } from "zustand";
import Api from "utils/wApi/index";

const useCart = create((set) => ({
	language: "koKr", // 표기언어
	timezone: "Asia/Seoul", // 시간대
	standByImg: "", // 대기화면 광고 이미지 url
	festival: "",
	branchLargeList: [], // 대카테고리
	branchMidList: [], // 중카테고리
	branchSmallList: [], // 소카테고리
	activeBranchList: ["", "", ""], // 선택된 카테고리 리스트 (대,중,소)
	menuList: [], // 상품 리스트

	cart: [], // 장바구니
	total: 0,
	active: null,
	loading: false,
	countdown: new Date(),

	// setter
	setLanguage: (value) => set(() => ({ language: value })),
	setTimezone: (value) => set(() => ({ timezone: value })),
	setStandByImg: (value) => set(() => ({ standByImg: value })),
	setFestival: (value) => set(() => ({ festival: value })),
	setBranchLargeList: async (item) => {
		set(() => ({ branchLargeList: item }));
	},
	setBranchMidList: async (item) => {
		set(() => ({ branchMidList: item }));
	},
	setBranchSmallList: async (item) => {
		set(() => ({ branchSmallList: item }));
	},
	setActiveBranchList: async (item) => {
		set(() => ({ activeBranchList: item }));
	},
	setMenuList: async (item) => {
		set(() => ({ menuList: item }));
	},
	increaseCart: async (item) => {
		if (!!useCart.getState().loading) return;
		set((state) => ({ loading: true }));
		const originPrice = item.paymentPrice / item.buyCount;
		try {
			const updatedPrice = Math.floor(item.paymentPrice + originPrice);
			const { data } = await Api.updateCount(null, item.id, {
				params: {
					count: 1,
					// price: item.paymentPrice + originPrice,
					price: updatedPrice,
				},
			});
			await useCart.getState().callCart();
		} catch (error) {
			alert(error.message);
		}
		set((state) => ({ loading: false }));
	},
	decreaseCart: async (item) => {
		if (!!useCart.getState().loading) return;
		set((state) => ({ loading: true }));
		const originPrice = item.paymentPrice / item.buyCount;
		try {
			const updatedPrice = Math.floor(item.paymentPrice - originPrice);
			const { data } = await Api.updateCount(null, item.id, {
				params: {
					count: -1,
					// price: item.paymentPrice - originPrice
					price: updatedPrice,
				},
			});
			await useCart.getState().callCart();
		} catch (error) {
			alert(error.message);
		}
		set((state) => ({ loading: false }));
	},
	removeCart: async (item) => {
		try {
			const { data } = await Api.removeOne(null, item.id);
			await useCart.getState().callCart();
		} catch (error) {
			alert(error.message);
		}
	},
	removeAllCart: async (item) => {
		try {
			const { data } = await Api.removeAll();
			await useCart.getState().callCart();
		} catch (error) {
			alert(error.message);
		}
	},
	callCart: async () => {
		try {
			const { data: cartData } = await Api.getCart();
			const total = cartData.data.list
				? cartData.data.list.reduce((acc, item) => acc + item.paymentPrice, 0)
				: 0;
			set((state) => ({ cart: cartData.data.list || [], total }));
		} catch (error) {
			// throw new Error(error?.message);
		}
	},

	setActive: async (item) => {
		set(() => ({ active: item }));
	},
	setCountdown: (value) =>
		set((state) => {
			const date = new Date();
			date.setMinutes(date.getMinutes() + value);
			return { countdown: date };
		}),
}));

export default useCart;
